export default function(){
  return window.location.href
}


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/base/methods/loginLinkRedirect.js